import { render, staticRenderFns } from "./DadosBancarios.vue?vue&type=template&id=d731f112&scoped=true&"
import script from "./DadosBancarios.vue?vue&type=script&lang=js&"
export * from "./DadosBancarios.vue?vue&type=script&lang=js&"
import style0 from "./DadosBancarios.vue?vue&type=style&index=0&id=d731f112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d731f112",
  null
  
)

export default component.exports